// extracted by mini-css-extract-plugin
export default {"outer":"LoadingView_outer__c9aIN","container":"LoadingView_container__8yGnw","fullscreen":"LoadingView_fullscreen__wr64H","message":"LoadingView_message__GMe8-"};